import React, { useContext, useEffect, useState } from 'react'
import CourseCard, { CourseCardSkeleton } from '../../../Components/CourseCard'
import { api } from '../../../api'
import { path } from '../../../constants'
import Preview from '../../Landing/Components/Preview'
import { settingsContext } from '../../../Context/settingsProvider'

export default function MyCourses() {
  const [courses, setCourses] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedCourse, setSelectedCourse] = useState(null)
  const {t} = useContext(settingsContext)

  useEffect(() => {
    api.get(path.myCourses).then(response => {
      const data = response.data
      if(data.success){
        setLoading(false)
        setCourses(data.courses)
      }
    })
  }, [])


  return (
    <div className='grid grid-cols-[repeat(auto-fill,minmax(320px,1fr))] max-md:grid-cols-[repeat(auto-fill,minmax(350px,1fr))] gap-x-4 gap-y-4 flex-1'>
      {!courses.length && !loading && <p className='whitespace-nowrap opacity-75 text-sm pt-6'>{t('NO_PURCHASES')}</p>}
        { loading ? new Array(4).fill(0).map(course => (
                <CourseCardSkeleton />
            )) : courses.map(course => (
                <CourseCard course={course} myTab setSelectedCourse={setSelectedCourse} />
          ))}
        {selectedCourse && <Preview setSelectedCourse={setSelectedCourse} selectedCourse={selectedCourse} /> }
    </div>
  )
}
